export default __webpack_public_path__ + "static/media/checkmark.92d1e81a.svg";